// extracted by mini-css-extract-plugin
export default {"imageBlock":"image_gallery_imageBlock__ZfcQI","item":"image_gallery_item__H3BRh","title":"image_gallery_title__HkhOA"};